import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ReactTable from "react-table";
import moment from "moment";

export default class Managers extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Manager_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	formatDate(val){
		return moment(val).local().format('MM/DD/YYYY h:mm A')

	}

	render(){
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: 'Ticket Number',
				accessor: 'ticket'
			},
			{
				Header: 'Modified On',
				id: 'date',
				accessor: obj => this.formatDate(obj.date)
			},
			{
				Header: 'Modified By',
				id: 'user',
				accessor: obj => obj.user ? `${obj.users.name_first} ${obj.users.name_last}` : 'N/A'
			},
			{
				Header: 'Modified Field',
				accessor: 'shown_field'
			},
			{
				Header: 'Original Value',
				id: 'value_old',
				accessor: obj => obj.actual_field === 'appointment_end' || obj.actual_field === 'appointment_start' ? this.formatDate(obj.value_old) : obj.value_old
			},
			{
				Header: 'Modified Value',
				id: 'value_new',
				accessor: obj => obj.actual_field === 'appointment_end' || obj.actual_field === 'appointment_start' ? this.formatDate(obj.value_new) : obj.value_new
			}
		];
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Logs')}
							{this.renderHeaderRight("Log",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		);
	}
}